import { EntityNames } from "../../enums/EntityNames";
import { httpPost } from "../Backend";
import HttpStatusCodes from "../HttpStatusCodes";

const root = `api/${EntityNames.recalls}`;

export default async function undoPick(recallId: string) {
    var response = await httpPost(`${root}/undoPick`, { recallId: recallId })
    return response.status === HttpStatusCodes.Ok;
}